import { FC } from "react";
import { Box, Stack, Typography } from "@mui/material";
import __ from "src/utils/Translations";
import NestedNotificationCheckbox from "./NestedNotificationCheckbox";
import {
  approverOptions,
  superiorOptions,
  employeeOptions,
  ahrOptions,
} from "./configurationOptions";

interface INotificationsConfigurationProps {
  disabled: boolean;
}

const NotificationsConfiguration: FC<INotificationsConfigurationProps> = ({
  disabled,
}) => (
  <Box
    sx={{
      bgcolor: "grey.100",
      padding: "1rem",
      marginBottom: "1rem",
      borderRadius: "0.5rem",
    }}
  >
    <Typography variant="subtitle1">
      {__("Wysyłaj powiadomienia mailowe")}
    </Typography>
    <Stack
      direction="row"
      justifyContent="space-evenly"
      spacing={4}
      mt="0.5rem"
    >
      <Box width="50%">
        <NestedNotificationCheckbox
          parentLabel="Powiadom akceptanta o:"
          parentName="approverNotifications"
          options={approverOptions}
          basePath="notificationsConfiguration"
          disabled={disabled}
        />
        <NestedNotificationCheckbox
          parentLabel="Powiadom bezpośredniego przełożonego o:"
          parentName="immediateSuperiorAndApproverNotifications"
          options={superiorOptions}
          basePath="notificationsConfiguration"
          disabled={disabled}
        />
      </Box>
      <Box width="50%">
        <NestedNotificationCheckbox
          parentLabel="Powiadom wnioskującego o zmianie statusu wniosku na:"
          parentName="employeeNotifications"
          options={employeeOptions}
          basePath="notificationsConfiguration"
          disabled={disabled}
        />
        <NestedNotificationCheckbox
          parentLabel="Powiadom AHR o:"
          parentName="ahrNotifications"
          options={ahrOptions}
          basePath="notificationsConfiguration"
          disabled={disabled}
        />
      </Box>
    </Stack>
  </Box>
);

export default NotificationsConfiguration;
